import { render, staticRenderFns } from "./expertMembersgf.vue?vue&type=template&id=0f3f2b70&scoped=true"
import script from "./expertMembersgf.vue?vue&type=script&lang=js"
export * from "./expertMembersgf.vue?vue&type=script&lang=js"
import style0 from "./expertMembersgf.vue?vue&type=style&index=0&id=0f3f2b70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3f2b70",
  null
  
)

export default component.exports